export const listenerLevels = [
  {
    level: 1,
    name: 'Nuevo Oyente',
    subtitle: 'Tu viaje comienza',
    pointsRequired: 0,
    icon: 'ri-user-smile-line',
    color: 'bg-foreground-500',
    colorLight: 'bg-foreground-100',
    textColor: 'text-foreground-600',
    benefits: [
      'Perfil de oyente básico',
      'Escuchar radios ilimitadas',
      'Acceso al dial digital',
    ],
    unlockedAt: 'Registro',
  },
  {
    level: 2,
    name: 'Activo',
    subtitle: 'Constancia que suma',
    pointsRequired: 200,
    icon: 'ri-user-heart-line',
    color: 'bg-emerald-500',
    colorLight: 'bg-emerald-100',
    textColor: 'text-emerald-700',
    benefits: [
      'Enviar saludos en vivo',
      'Solicitar canciones',
      'Guardar radios favoritas',
      'Insignia Activo',
    ],
    unlockedAt: '200 pts',
  },
  {
    level: 3,
    name: 'Fan',
    subtitle: 'La pasión se nota',
    pointsRequired: 800,
    icon: 'ri-user-star-line',
    color: 'bg-sky-500',
    colorLight: 'bg-sky-100',
    textColor: 'text-sky-700',
    benefits: [
      'Participar en concursos',
      'Asistir a eventos RFW',
      'Compartir contenido',
      'Insignia Fan',
      'Prioridad en solicitudes',
    ],
    unlockedAt: '800 pts',
  },
  {
    level: 4,
    name: 'Top Fan',
    subtitle: 'Destacás entre miles',
    pointsRequired: 2500,
    icon: 'ri-fire-line',
    color: 'bg-orange-500',
    colorLight: 'bg-orange-100',
    textColor: 'text-orange-700',
    benefits: [
      'Menciones al aire',
      'Acceso anticipado a eventos',
      'Insignia Top Fan',
      'Estadísticas avanzadas',
      'Soporte prioritario',
    ],
    unlockedAt: '2,500 pts',
  },
  {
    level: 5,
    name: 'VIP',
    subtitle: 'Experiencia exclusiva',
    pointsRequired: 6000,
    icon: 'ri-vip-diamond-line',
    color: 'bg-amber-500',
    colorLight: 'bg-amber-100',
    textColor: 'text-amber-700',
    benefits: [
      'Badge VIP dorado',
      'Contenido exclusivo',
      'Meet & greet con locutores',
      'Prioridad máxima en todo',
      'Regalos RFW trimestrales',
      'Invitación a eventos VIP',
    ],
    unlockedAt: '6,000 pts',
  },
  {
    level: 6,
    name: 'Embajador RFW',
    subtitle: 'La voz de la comunidad',
    pointsRequired: 15000,
    icon: 'ri-vip-crown-line',
    color: 'bg-rose-500',
    colorLight: 'bg-rose-100',
    textColor: 'text-rose-700',
    benefits: [
      'Insignia Embajador RFW',
      'Perfil verificado permanente',
      'Voz y voto en la comunidad',
      'Acceso a betas y nuevas funciones',
      'Reconocimiento en homepage RFW',
      'Merchandising oficial',
      'Evento anual con fundadores',
    ],
    unlockedAt: '15,000 pts',
  },
];

export const currentListenerProfile = {
  name: 'Marco Antonio Rivera',
  username: '@marco_oyente',
  photo: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Latino%20man%20in%20his%20late%2020s%20with%20warm%20confident%20smile%2C%20dark%20hair%2C%20studio%20portrait%20with%20clean%20minimal%20neutral%20background%2C%20editorial%20portrait%20photography%20with%20soft%20natural%20lighting&width=200&height=200&seq=niveles-profile&orientation=squarish',
  currentPoints: 4850,
  currentLevel: 4,
  currentLevelName: 'Top Fan',
  nextLevelName: 'VIP',
  pointsToNextLevel: 6000,
  progressPercent: 67,
  totalListenersAtLevel: 847,
  globalRank: 4231,
};